import React, { useRef, useState, useEffect } from "react"
import * as Style from "./CourseSidebarVideo.module.scss"
import { Link } from "gatsby"
import Checked from "../../images/checked.svg"
import Unchecked from "../../images/unchecked.svg"

const CourseSidebarVideo = ({ video, list_number, lesson_id, watchedVids }) => {
  const [watched, setWatched] = useState(false)

  useEffect(() => {
    if (watchedVids) {
      if (watchedVids.includes(video.strapi_id)) {
        setWatched(true)
      }
    }
  }, [watchedVids])

  return (
    <Link to={`../${video.id}`}>
      <div
        className={Style.video}
        style={
          video.id == lesson_id
            ? { background: "#EFEFEF" }
            : { background: "transparent" }
        }
      >
        <div className={Style.video_preview}>
          <img width="100%" height="100%" src={video.thumbnail} alt="video thumbnail"/>
        </div>
        <div className={Style.video_info}>
          <div className={Style.name}>
            {list_number}. {video.title}
          </div>
          <div className={Style.container}>
            <div className={Style.time}>{video.playtime}</div>
            {watched ? <Checked /> : <Unchecked />}
            <div
              className={Style.watched}
              style={watched ? { color: "#1A7196" } : { color: "#A3A3A3" }}
            >
              Watched
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default CourseSidebarVideo
